<app-modal [header]="'admintool.input_series.title' | translate">
  <div modal-body class="d-flex flex-column h-100">
    <label for="seriesInput">{{ 'admintool.input_series.label' | translate }}</label>
    <input
      id="seriesInput"
      type="text"
      class="form-control mt-1"
      [formControl]="seriesControl"
      (keyup.enter)="confirm()"
      autofocus
    />
    @if (seriesControl.invalid && seriesControl.touched) {
      <div class="text-danger mt-1 small">
        {{ 'admintool.input_series.validation_error' | translate }}
      </div>
    }
  </div>
  <button modal-footer class="btn btn-secondary btn-cancel" type="button" (click)="cancel()">{{ 'global.label.cancel' | translate }}</button>
  <button modal-footer class="btn btn-primary btn-cancel" type="button" (click)="confirm()">{{ 'global.label.ok' | translate }}</button>
</app-modal>
